exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hoverable[data-v-50187b67]:hover {\n  background: rgba(214, 69, 113, 0.1);\n}\n.hover-delete[data-v-50187b67],\n.hover-edit[data-v-50187b67],\n.hover-save[data-v-50187b67] {\n  color: #6c757d;\n}\n.hover-delete[data-v-50187b67]:hover {\n  color: #dc3545;\n}\n.hover-cancel[data-v-50187b67]:hover {\n  color: #ffc107;\n}\n.hover-save[data-v-50187b67]:hover {\n  color: #28a745;\n}\n.selected[data-v-50187b67],\n.selected[data-v-50187b67]:hover {\n  background: #d64571;\n  color: white;\n}\n.taller[data-v-50187b67] {\n  height: 8rem;\n  font-size: 85%;\n}", ""]);

// exports
